/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the TipologiaBlocco interface.
 */
export function instanceOfTipologiaBlocco(value) {
    return true;
}
export function TipologiaBloccoFromJSON(json) {
    return TipologiaBloccoFromJSONTyped(json, false);
}
export function TipologiaBloccoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}
export function TipologiaBloccoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'value': value['value'],
    };
}
